export const handleAbTestEvent = (
  choixAbTest: string,
  usersheetId: string,
  save: (responses: { key: string; response: string }[], usersheetId?: string) => void,
) => {
  // En attendant d'avoir une implémentation de tags fiable à 100%,
  // on va utiliser un système qui permet de n'appeler la sauvegarde qu'une seule fois quoiqu'il arrive
  if (globalThis.abTestEventFired) {
    return
  }

  globalThis.abTestEventFired = true
  save([{ key: 'ChoixAbTest', response: choixAbTest }], usersheetId)
}
